import React, { useState, useRef, useEffect } from 'react';
import { OtpInput } from 'reactjs-otp-input';
import './OtpForm.scoped.scss';
import { apiClient, urlClientInfo } from "../../../../api";

const OTP_LENGTH = 6;

const OtpForm = ({
  callRegisterApi, state, setState, model, setModel, callGetOTP, loading
}) => {
  const expireSeconds = 60
  const [timer, setTimer] = useState(expireSeconds);
  const intervalRef = useRef();

  const callVerifyOtp = async (event) => {
    event.preventDefault(); // Prevents page reload

    let req = {
      otpid: model.OTPid,
      otpcode: model.OTPcode,
      otpRef : model.OTPref,
      email: model.email
    };

    await apiClient
      .post("api/accountregister/verifyotp", req, {
        headers: { "Content-type": "application/json; charset=UTF-8" },
      })
      .then((response) => {
        if (response.data.verifyResult) {
          callRegisterApi();
        } else {
          setState({
            ...state,
            otpErrorMessage: response.data.message,
            showOtpErrorMessage: true,
          });
        }
      })
      .catch((error) => {
        setState({
          ...state,
          otpErrorMessage: error.message,
          showOtpErrorMessage: true,
        });
      });
  };

  const handleChangeOTP = (value) => {
    setModel({
      ...model,
      OTPcode: value,
    })
    setState({
      ...state,
      otpErrorMessage: "",
      showOtpErrorMessage: false,
    });
  }

  useEffect(() => {
    setTimer(expireSeconds);
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, [expireSeconds, model.OTPref]);

  return (
    <div className="otp-form-container">
      <div className="otp-form-title">Verify OTP</div>
      <div className="otp-form-desc">
        Please enter the OTP that you received via email : <span className="otp-form-email">{model.email}</span>
      </div>
      <form className="otp-form-content" onSubmit={callVerifyOtp} autoComplete="off">
        <div className="otp-input-row">
          <OtpInput
            value={model.OTPcode}
            onChange={(value) => handleChangeOTP(value)}
            numInputs={OTP_LENGTH}
            isInputNum
            shouldAutoFocus
            inputStyle="otp-input-box"
            focusStyle="otp-input-box-focus"
            containerStyle="otp-input-container"
            hasErrored={!!state.otpErrorMessage}
            errorStyle="otp-input-box-error"
            placeholder="-"
          />
        </div>
        <div className="otp-form-meta-row">
          <div className="otp-form-ref">OTP ref : <span>{model.OTPref}</span></div>
          <div className="otp-form-timer">

            {timer !== 0 ? (
              <div className='otp-form-timer-box'>
                <p className='expire-within'>Expire within <span className="otp-form-timer-value">{timer}</span> s.</p>
              </div>
            ) : (
              <button type="button" className="otp-form-resend" onClick={() => {callGetOTP(); setState({ ...state, otpErrorMessage: "" })}} disabled={loading}>
                Resend OTP
              </button>
            )}
          </div>
        </div>
        {state.otpErrorMessage && <div className="otp-form-error">{state.otpErrorMessage}</div>}
        <button
          type="submit"
          className="otp-form-confirm-btn"
          disabled={model.OTPcode.length !== OTP_LENGTH || loading}
        >
          {loading ? 'Verifying...' : 'Confirm'}
        </button>
      </form>
    </div>
  );
};

export default OtpForm;